// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { ENV_HQSPORT_COMMON } from '../common/environment';

export const ENV_HQSPORT_MOBILE = {
  production: false,
  appId: 'com.hqsportdev.plus',
  appName: 'HQ Sport+ Dev',
  appPlatformId: {
    android: 'com.hqsportdev.plus',
    ios: '', //TODO: Susana pendiente de añadir el ID de ios cuando lo sepamos
  },
  webDir: '../../dist/apps/mobile-hqsport/development',

  oAuthGoogle: {
    authorizationBaseUrl: ENV_HQSPORT_COMMON.oAuthGoogle.authorizationBaseUrl,
    accessTokenEndpoint: ENV_HQSPORT_COMMON.oAuthGoogle.accessTokenEndpoint,
    scope: ENV_HQSPORT_COMMON.oAuthGoogle.scope,
    resourceUrl: ENV_HQSPORT_COMMON.oAuthGoogle.resourceUrl,
    web: {
      appId: '572252113056-3dv1m1e7hv7tkio3ndmer0ili7hlftpt.apps.googleusercontent.com',
      responseType: ENV_HQSPORT_COMMON.oAuthGoogle.web.responseType,
      accessTokenEndpoint: ENV_HQSPORT_COMMON.oAuthGoogle.web.accessTokenEndpoint,
      redirectUrl: 'http://localhost:8100',
      windowOptions: ENV_HQSPORT_COMMON.oAuthGoogle.web.windowOptions
    },
    android: {
      appId: '572252113056-3dv1m1e7hv7tkio3ndmer0ili7hlftpt.apps.googleusercontent.com',
      responseType: 'code', // if you configured an android app in google dev console the value must be 'code'
      redirectUrl: 'com.azzulei.tv:/' // package name from google dev console
    },
    ios: {
      appId: '',
      responseType: 'code', // if you configured a ios app in google dev console the value must be 'code'
      redirectUrl: 'com.azzulei.tv:/' // Bundle ID from google dev console
    }
  },
  oAuthMicrosoft: {
  },

  adMob: {
    android: {
      appId: 'ca-app-pub-1058541756837624~3835466860',
      adUnitBanner: 'ca-app-pub-3940256099942544/9214589741',   // Test Ad Unit
      adUnitInterstitial: 'ca-app-pub-3940256099942544/1033173712',   // Test Ad Unit
      adUnitRewardInterstitial: ''
    },
    ios: {
      appId: 'ca-app-pub-1058541756837624~7867594104',
      adUnitBanner: 'ca-app-pub-3940256099942544/2435281174',   // Test Ad Unit
      adUnitInterstitial: 'ca-app-pub-3940256099942544/4411468910',   // Test Ad Unit
      adUnitRewardInterstitial: ''
    }
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
